/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'edit': {
    width: 12,
    height: 11,
    viewBox: '0 0 12 11',
    data: '<defs><linearGradient id="svgicon_edit_a" x1="731.215%" x2="-235.103%" y1="50%" y2="50%"><stop offset="0%" stop-color="#2AD8E5"/><stop offset="100%" stop-color="#17A7C7"/></linearGradient><linearGradient id="svgicon_edit_b" x1="731.215%" x2="-235.103%" y1="50%" y2="50%"><stop offset="0%" stop-color="#2AD8E5"/><stop offset="100%" stop-color="#17A7C7"/></linearGradient></defs><g _fill="none" fill-rule="evenodd"><path pid="0" _stroke="url(#svgicon_edit_a)" stroke-linecap="round" stroke-linejoin="round" d="M9.669 2.859L6.785 0 1.429 5.313a.476.476 0 00-.112.172L.187 9.199l3.851-.81a.483.483 0 00.19-.117l5.14-5.112.301-.301z" transform="translate(1 1)"/><path pid="1" _stroke="url(#svgicon_edit_b)" stroke-linecap="square" d="M5.526 1.273l2.632 2.546" transform="translate(1 1)"/></g>'
  }
})
